<template>
  <section class="row">
    <div class="col-12">
      <div class="card shadow">
        <div
          class="card-body px-md-4 py-md-5 rounded-4 py-4 transition-shadow
          box-shadow-yellow-300 box-shadow-hover-yellow-300"
        >
          <div class="row">
            <div class="col-1 pe-0">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-10">
              <div class="h5 text-center mb-3">
                Ajouter une carte bancaire
              </div>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <div class="row w-100">
                <div
                  v-for="(elem, iter) in listElements"
                  :key="elem.name"
                  class="text-left d-flex flex-column my-2"
                  :class="[
                    iter === 0 ? 'col-12' : 'col-6',
                  ]"
                >
                  <label
                    :for="`card-${elem.name}`"
                    class="text-secondary mb-1"
                  > {{ elem.label }} </label>
                  <div :id="`card-${elem.name}`" />
                  <transition
                    tag="div"
                    @enter="tf_slideDown"
                    @leave="tf_slideUp"
                  >
                    <div
                      v-if="elem.event.error !== undefined"
                      :id="`card-${elem.name}-error`"
                      class="animated"
                    >
                      <small
                        role="alert"
                        class="text-danger"
                        v-text="elem.event.error.message"
                      />
                    </div>
                  </transition>
                </div>
                <transition
                  tag="div"
                  @enter="tf_slideDown"
                  @leave="tf_slideUp"
                >
                  <div
                    v-if="error !== null"
                    class="col-12"
                  >
                    <div class="text-danger text-left mt-2">
                      {{ error }}
                    </div>
                  </div>
                </transition>
                <div
                  key="next-button"
                  class="col-12 mt-3"
                >
                  <v-loader
                    :next="nextStep"
                    title="Enregistrer ma nouvelle carte bancaire"
                    class="w-100"
                  />
                  <button
                    type="button"
                    class="btn btn-block w-100 mt-2"
                    @click="() => $router.back()"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { pick } from 'lodash-es';
import { transform, routing, ui } from '@/mixins';

import list from '@/assets/data/listElements.json';

export default {
  name: 'AccountPaymentAddCard',
  mixins: [transform, routing, ui],
  data() {
    return {
      showForm: false,
      editMode: false,
      error: '',
      stripe: {},
      listElements: list.listElements,
    };
  },
  computed: {
    account() { return this.$store.state.checkout; },
    creditCards() {
      return this.$store.getters['payments/paymentMethods']
        .filter(({ type }) => type === 'CARD');
    },
    activeCreditCard() {
      return this.creditCards.find(({ active }) => active);
    },
    cardNumber() {
      return 'XXXX XXXX XXXX XXXX';
    },
  },
  mounted() {
    this.stripe = window.Stripe(import.meta.env.VITE_STRIPE_KEY);
    this.setContainer();
  },
  beforeDestroyed() {
    this.unsetContainer();
  },
  methods: {
    cardName: (elem) => `card-${elem.name}`,
    async nextStep() {
      const { stripe } = this;
      const { container } = this.listElements[0];
      try {
        await this.$store.dispatch('payments/addCreditCard', [stripe, container]);
        this.ui_accountModal({ type: 'creditCard', value: true });
        this.$emit('show', false);
        await this.$store.dispatch('payments/getPaymentMethods');
        return Promise.resolve();
      } catch (err) {
        if (err.response && err.response.status === 409) {
          this.error = 'Cette carte existe déja pour cette entreprise';
        } else {
          this.error = 'Veuillez vérifier les informations de votre carte';
        }
        return Promise.reject();
      }
    },
    unsetContainer() {
      this.listElements.forEach((elem) => {
        const id = this.cardName(elem);
        const shadow = elem;
        document.getElementById(id).removeEventListener('change',
          (event) => { shadow.event = event; });
      });
    },
    setContainer() {
      const { stripe } = this;
      if (stripe) {
        const elements = stripe.elements();
        this.listElements.forEach((elem) => {
          const newElem = elements.create(`card${elem.name}`,
            pick(elem, ['style', 'placeholder', 'classes']));
          newElem.mount(`#${this.cardName(elem)}`);
          newElem.addEventListener('change', (event) => {
            Object.assign(elem, { event });
          });
          Object.assign(elem, { container: newElem });
        });
      }
    },
    setShowForm(value) {
      this.showForm = value;
    },
    setEditMode(value) {
      this.editMode = value;
    },
  },
};
</script>
